"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ContactattachmentOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#616DDC",
    clipPath: "url(#prefix__contactattachment-outline__clip0_13467_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.742 7.402v6.229a1.37 1.37 0 01-1.37 1.37H4.199a1.375 1.375 0 01-1.375-1.37V4.133h3.96a.5.5 0 01.154-.295l.785-.705H2.824v-.755A1.375 1.375 0 014.2 1.004h5.169a.5.5 0 000-1h-5.17a2.374 2.374 0 00-2.373 2.374v2.875H.5a.5.5 0 100 1h1.325v2.749H.5a.5.5 0 000 1h1.325v2.719H.5a.5.5 0 000 1h1.33A2.37 2.37 0 004.199 16h8.173a2.37 2.37 0 002.37-2.37V6.503l-1 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.063 8.002a1.81 1.81 0 00-1.735-1.275 1.835 1.835 0 101.83 1.83 1.855 1.855 0 00-.095-.555zm-1.735 1.56a1 1 0 111-1 1 1 0 01-1 .98v.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.329 13.5v-.45a3.07 3.07 0 011.075-2.344.81.81 0 01.884-.11 2.214 2.214 0 002.085 0 .8.8 0 01.88.105 3.074 3.074 0 011.074 2.345v.455H4.33zm.895-.854h4.209a2.2 2.2 0 00-.71-1.245 3.05 3.05 0 01-2.79 0 2.2 2.2 0 00-.71 1.22v.025zM11.027 7.777a2.145 2.145 0 01-.74-.135 2.125 2.125 0 01-1.4-1.744 2 2 0 01.705-1.73l2.625-2.314a1.385 1.385 0 011.85-.115 1.36 1.36 0 01.5 1.034 1.501 1.501 0 01-.5 1.145l-2.5 2.194a.5.5 0 11-.665-.75l2.5-2.194a.499.499 0 00.17-.38.34.34 0 00-.145-.285c-.2-.165-.43 0-.55.095l-2.625 2.315a1 1 0 00-.37.86 1.125 1.125 0 00.75.924 1.075 1.075 0 001.13-.195l2.53-2.23a1.944 1.944 0 00.624-2.024 1.73 1.73 0 00-1.22-1.174 1.68 1.68 0 00-1.564.325l-2.634 2.35a.508.508 0 01-.69-.746L11.497.65a2.67 2.67 0 012.5-.54 2.76 2.76 0 011.904 1.81 2.949 2.949 0 01-.95 3.084l-2.5 2.22c-.386.36-.896.558-1.424.554z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__contactattachment-outline__clip0_13467_48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

ContactattachmentOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ContactattachmentOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ContactattachmentOutline;
exports["default"] = _default;